import { types } from "../action-types";

const initialState = {
    loading: false,
    photos:[],
    error: false,
};

const getCulturePhotos = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CULTURE_PHOTOS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.GET_CULTURE_PHOTOS_SUCCESS:
            return {
                ...state,
                loading: false,
                photos: action.payload,
                error: false,
            };
        case types.GET_CULTURE_PHOTOS_FAILURE:

            return {
                ...state,
                loading: false,
                photos: [],
                error: true,
            };
        default:
            return state;
    }
};

export default getCulturePhotos;
